export function getVisitorsExperiments() {
  if (!window.optimizely) {
    return '';
  }

  const experimentStates = window.optimizely.get('state').getExperimentStates();

  const experiments = Object.values(experimentStates).map(({
    experimentName, id, variation,
  }) => {
    return `[${experimentName} (${id}) | ${variation.name} (${variation.id})]`;
  });

  return experiments.join(' ');
}
